import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, FormGroup, TextField } from "@mui/material";
import { useEffect, useReducer, useState } from "react";
import api, { UserProfileDto, UserUpdateDto, UserUpdateDtoRole } from "../../../api";
import { createStateReducer, isEmpty, notif } from "../../utils";
import { RepeatPasswordControl } from "./RepeatPasswordControl";
import { UserRoleList } from "./UserRoleList";

export default interface UserDialogProps {
  user: Partial<UserUpdateDto> | null;
  onSubmit?: (dto: UserProfileDto | null, action: "added" | "updated" | "closed") => void;
}

export const UserDialog = (props: UserDialogProps) => {
  const { user, onSubmit } = props;
  const [open, setOpen] = useState(false);
  const reducer = createStateReducer<UserUpdateDto>();
  const [state, dispatch] = useReducer(reducer, null);
  const [passwordValid, setPasswordValid] = useState(true);

  const handleAccept = async () => {
    try {
      if (!passwordValid) {
        notif("Entered passwords are not equal", "error");
      } else {
        if (state?.id) {
          const user = await api.user.update(state as any);
          if (onSubmit) onSubmit(user, "updated");
          setOpen(false);
        } else {
          if (isEmpty(state?.password ?? "")) {
            notif("Password required when creating user", "error");
          } else {
            const user = await api.user.add(state as any);
            if (onSubmit) onSubmit(user, "added");
            setOpen(false);
          }
        }
      }
    } catch (err) {
      notif(err, "error");
    }
  };
  const handleClose = () => {
    if (onSubmit) onSubmit(null, "closed");
    setOpen(false);
  };

  const handlePasswordChange = (value: string, isValid: boolean) => {
    dispatch({ state: { password: value } });
    setPasswordValid(isValid);
  }

  useEffect(() => {
    if (user !== null) {
      dispatch({ state: user, replace: true });
      setPasswordValid(true);
      setOpen(true);
    }
  }, [user]);

  const adding = (): boolean => {
    return state?.id ? false : true;
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm">
      <DialogTitle>{state?.id ? "EDIT USER" : "ADD USER"}</DialogTitle>
      <DialogContent dividers>
        <FormGroup sx={{ minWidth: 300 }}>
          <TextField label="Email" required variant="standard" value={state?.email ?? ""} onChange={(e) => dispatch({ state: { email: e.target.value } })} />
          <RepeatPasswordControl required={adding()} onChange={handlePasswordChange} />
          <Box sx={{ p: 1 }} />
          <UserRoleList value={state?.role ?? UserUpdateDtoRole.Admin} onChange={(value) => dispatch({ state: { role: value } })} />
          <FormControlLabel label="Enabled" control={<Checkbox checked={state?.isEnabled ?? false} onChange={(e, c) => dispatch({ state: { isEnabled: c } })} />} />
        </FormGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleAccept}>Accept</Button>
        <Button onClick={handleClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};
